import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfileSummaryComponent } from "../../components/profile-summary/profile-summary.component";
import { ProfileRoomUpgradeComponent } from "../../components/profile-room-upgrade/profile-room-upgrade.component";
import { ProfileBookerDetailsComponent } from "../../components/profile-booker-details/profile-booker-details.component";
import { ExtrasComponent } from "../../components/extras/extras.component";
import { ProfilePaymentComponent } from "../../components/profile-payment/profile-payment.component";
import { ExtrasService, IExternalExtra, IExtra, LoaderService, paymentError, ReservationService, ShopCart, ShopcartService } from 'core-lib';
import { AvailabilityService } from 'core-lib';
import { ICartItem, ISearchParams, IRoomUpgradeItem, IRoomUpgradeConfigItem, IShopCart, IProfileData } from 'core-lib';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsService } from 'core-lib';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PaymentSummaryComponent } from "../../components/payment-summary/payment-summary.component";
import { Subscription } from 'rxjs';
import { PimNotificationComponent } from 'core-lib';
import { DialogModule } from 'primeng/dialog';
import { forEach, isArray } from 'lodash';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-profile',
    imports: [
        ProfileSummaryComponent,
        ProfileRoomUpgradeComponent,
        ProfileBookerDetailsComponent,
        ExtrasComponent,
        ProfilePaymentComponent,
        TranslateModule,
        ButtonModule,
        PaymentSummaryComponent,
        PimNotificationComponent,
        DialogModule
    ],
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit, OnDestroy {

  shopCart: IShopCart;
  extras: IExtra[];
  externalExtras: IExternalExtra[];
  roomCount: number;
  searchParams: ISearchParams | null;
  roomUpgrade:null|IRoomUpgradeItem = null;
  validationData:Array<IProfileData|null> = [];
  profiles: [];
  paymentFailed: null|paymentError = null;
  ticketExtraId:undefined|string;
  private subs: Subscription[] = [];


  constructor(
    private shopCartService: ShopcartService, 
    private avService: AvailabilityService, 
    private settings: SettingsService, 
    private router:Router,
    private extrasService: ExtrasService,
    private reservationService: ReservationService,
    private loader: LoaderService,
  ) {

  }

  ngOnInit(): void {

    this.paymentFailed = this.reservationService.paymentError;
    this.subs.push(
      this.shopCartService.shopCart$.subscribe((cart: IShopCart | null) => {
        if (cart) {
          this.shopCart = new ShopCart(cart.items); // create a new object reference, so the change is triggered in onChanges of child components
          this.roomCount = cart.getCartItemsByType('roomrate').length;

          if (this.roomCount == 1) {
            //room upgrades only for single room bookings
            // not implemented yet, but the method is there and can be called to get the possible upgrade for the room in the cart
            //this.getRoomUpgrades();
          }

        }
        else {
          this.router.navigate(['home']);
        }

      })
    );

    
   
    this.extrasService.getExtras().subscribe((res) => {
      let filteredExtras: IExtra[] = [];
      if (isArray(res)) {
        filteredExtras = this.filterHiddenExtras(res);
      }
      this.ticketExtraId = this.settings.get('profile.externalExtraId');

      if (this.ticketExtraId) {
        // if found extra with isTicket flag, do not show it
        filteredExtras = filteredExtras.filter((item) => {return item.isTicket != true});
        this.extrasService.getExternalExtras().subscribe((res) => {
            if (res) {
              this.externalExtras = res;
            }
        });
      }
      
      this.extras = filteredExtras;
    });




    setTimeout(() => {
      this.shopCart.getCartItemsByType('roomrate').forEach((item) => {
        this.validationData.push(null);
      });
    }, 100);



    this.searchParams = this.avService.getSearchParams();

  }

  returnToAvailability() {
    this.router.navigate(['availability']);
  };

  getRoomUpgrades() {
    let upgSettings = this.settings.get('profile.roomUpgrade');
    let roomCode = this.shopCart.getFirstCartItem().item.room.roomCode;
    let currentRateCode = this.shopCart.getFirstCartItem().item.rate.rateCode;

    // get the upgrade configuration from settings
    let upgradeItemConfig = upgSettings.find((upgItem: IRoomUpgradeConfigItem) => upgItem.from.includes(roomCode));

    if (upgradeItemConfig) {

      let upgradeRoomCode = upgradeItemConfig.to[0];

      // find the availability for the upgrade item. the room code must match the config item
      // also the roomrate has to have the same ratecode as the currently selected ratecode.
      this.avService.availability$.subscribe((av: any) => {
        if (av) {
          //find the room data
          let upgRooms = av[0].filter((room: any) => {

            // chech that it has the same rate
            let roomRate = room.roomrates.find((rr: any) => {
              return rr.rate.rateCode == currentRateCode;
            });
            return (room.roomCode == upgradeRoomCode) && roomRate;
          });
          // filter other rates away from the object
          upgRooms.forEach((room: any) => {
            room.roomrates = room.roomrates.filter((rr: any) => {
              return rr.rate.rateCode == currentRateCode;
            });
          });

          if (upgRooms.length > 0) {
            this.roomUpgrade = {
              config: upgradeItemConfig,
              roomrate: upgRooms[0],
            }
          }

        }

      });
      this.avService.fetchAvailability();
    }


  }

  handleProfileDataChange(roomIndex: number, data: IProfileData) {
    this.validationData[roomIndex] = data;
    this.validationData = JSON.parse(JSON.stringify(this.validationData));
  }

  filterHiddenExtras(extras: IExtra[]) {
    if (extras.length) {
      let filtered = extras.filter((extra) => {
        return !extra.appliedRules?.hiddenInAllRoomTypes
      });
      return filtered;
    }
    return extras
  }

  disablePaymentFailedError() {
    this.paymentFailed = null;
    this.reservationService.paymentError = null;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
